if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.submitButton = null;
        this.idInput = null;
        this.form = this.querySelector("form");
        if(this.form) {
          this.submitButton = this.querySelector('[type="submit"]');
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
          this.idInput = this.form.querySelector("[name=id]");
          if(this.idInput) {
            this.idInput.disabled = false;
          }
        }

        // Initialize name plate validation if the component has the data attribute
        if (this.hasAttribute('data-name-plate')) {
          this.initializeNamePlateValidation();
        }
      }

      initializeNamePlateValidation() {
        this.namePlateInput = this.querySelector('#name-plate-input');
        this.emojiWarning = this.querySelector('#emoji-warning');

        if (!this.namePlateInput || !this.emojiWarning) return;

        this.emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;

        this.namePlateInput.addEventListener('input', () => {
          this.validateNamePlateInput();
        });
      }

      validateNamePlateInput() {
        if (!this.namePlateInput || !this.emojiWarning) return;

        const inputValue = this.namePlateInput.value || '';
        const hasEmoji = this.emojiRegex.test(inputValue);

        this.emojiWarning.style.display = hasEmoji ? 'block' : 'none';

        if (hasEmoji) {
          this.namePlateInput.value = inputValue.replace(this.emojiRegex, '');
        }

        // Update the data attribute with the current value
        this.setAttribute('data-name-plate', this.namePlateInput.value);
      }

      async handleAddToCart(id, quantity = 0, properties, warmWeatherData) {
        if (!id) return;

        const items = [];
        const item = {
          id,
          quantity,
          properties
        };

        if (warmWeatherData) {
          items.push({
            id: warmWeatherData.id,
            quantity: warmWeatherData.quantity,
            properties: warmWeatherData.properties
          });
        }

        if (this.hasAttribute('data-coolers') && this.dataset.coolers.trim() != '') {
          const coolers = this.dataset.coolers.trim().split(',');
          coolers.forEach(cooler => items.push({ id: cooler, quantity }))
        }

        items.push(item);

        await window.theme
          .addToCart(items)
          .then((result) => {
            if (result.error) {
              this.handleErrorMessage(result.error);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              soldOutMessage.textContent = result.error;
              this.error = true;
              return;
            }
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              quickAddModal.hide(true);
            }
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            document.dispatchEvent(new CustomEvent("cart:update"));
          });
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.formError = false;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const id = this.form.querySelector("[name=id]").value;
        const quantity =
          parseInt(document.querySelector("[data-cart-quantity]")?.value) || 1;
        const propertiesFields = this.form.querySelectorAll('[name^="properties"]');
        const properties = {};

        // Capture the data-name-plate attribute value if available
        const namePlateValue = this.getAttribute("data-name-plate");
        if (namePlateValue && namePlateValue.trim() !== "") {
          properties["Name Plate"] = namePlateValue;
        }

        if (this.hasAttribute("data-warm-weather-shipping")) {
          properties["_warmWeatherShipping"] = this.getAttribute(
            "data-warm-weather-shipping"
          );
        }

        propertiesFields.forEach(propertiesField => {
          const fieldKey = propertiesField.name.match(/\[(.+?)\]/)[1];
          const fieldValue = propertiesField.value.trim();

          if (fieldValue !== '' && !propertiesField.hasAttribute('required')) {
            return;
          } else if (fieldValue === '' && propertiesField.hasAttribute('required')) {
            this.handleFieldErrorMessage(propertiesField);
            this.formError = true;
            return;
          }

          properties[fieldKey] = fieldValue;

          const closestField = propertiesField.closest('.product-form__field');
          const errorMessage = closestField?.querySelector('[data-error-message]');
          if(errorMessage) {
            errorMessage.classList.add('hidden');
          }
        });

        if (this.formError) {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');

          return;
        }

        this.handleAddToCart(
          id,
          quantity,
          properties,
          properties["_warmWeatherShipping"] && {
            id: this.getAttribute("data-warm-weather-shipping"),
            quantity: 1,
            properties: { _isWarmWeatherShippingProduct: true },
          }
        );
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      handleFieldErrorMessage(field) {
        if(!field) return;
        const fieldErrorMessage = field.closest('.product-form__field')?.querySelector('[data-error-message]');

        if (fieldErrorMessage) {
          fieldErrorMessage.classList.remove('hidden');
        }
      }
    }
  );
}
